import { ProviderGroupControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Rajkumar Rathod
 */
export const useAddPatientIdConfig = () =>
  useMutationWithLoading(
    async (param: { ecarehealthPatientId: string; xTENANTID?: string }) =>
      new ProviderGroupControllerApi(getConfigObject()).addEcareHealthPatientId(
        param?.ecarehealthPatientId,
        param?.xTENANTID
      )
  );
